import { REDUCER } from '../reducers/reducersConst';

/**
 * ROUTE REDUCER
 */
let defaultRouteState = {
  inClassroom: false,
  inBook: false,
  indexTransition: false,
  location: undefined,
  history: [],
  params: {},
  inProfile: false,
  redirectAfterLogin: ''
};

export let router = (state = defaultRouteState, action) => {
  switch (action.type) {
    case REDUCER.ROUTE.SET_IN_CLASSROOM:
      return {
        ...state,
        inClassroom: action.inClassroom
      };
    case REDUCER.ROUTE.SET_IN_BOOK:
      return {
        ...state,
        inBook: action.inBook
      };
    case REDUCER.ROUTE.SET_IN_PROFILE:
      return {
        ...state,
        inProfile: action.inProfile
      };
    case REDUCER.ROUTE.SET_INDEX_TRANSITION:
      return {
        ...state,
        indexTransition: action.indexTransition
      };
    case REDUCER.ROUTE.SET_APP_LOCATION:
      return {
        ...state,
        location: action.location
      };
    case REDUCER.ROUTE.SET_APP_PARAMS:
      return {
        ...state,
        params: action.params
      };
    case REDUCER.ROUTE.SET_APP_HISTORY:
      return {
        ...state,
        history: action.history
      };
    case REDUCER.ROUTE.SET_REDIRECT_AFTER_LOGIN:
      return {
        ...state,
        redirectAfterLogin: action.redirectAfterLogin
      };
    case REDUCER.ROUTE.CLEAR_REDIRECT_AFTER_LOGIN:
      return {
        ...state,
        redirectAfterLogin: ''
      };
    default:
      return state;
  }
};
